$(function () {

    // Add/remove css classes when js is ready
    $('.site_header').addClass('site_header--js-ready');
    $('.menu-item-has-children ul').addClass('hidden');
    $('.site_header__navigation-links').addClass('hidden');
    $('.site_header__navigation').addClass('hidden');
    $('.sub-menu').addClass('js-ready');

    // Append arrow to each list item
    var navChevron = '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M7,10L12,15L17,10H7Z" /></svg>';
    $('.site_header__navigation-links li a').append(navChevron);
    $('.site_header__navigation__top-links li a').append(navChevron);

    // Append nav toggle buttons to header
    var navOpenMarkup = '<button class="nav-toggle nav-toggle--open"><img src="/wp-content/themes/cgit-qc-hub/dist/images/icons/hamburger.png" alt=""></button>';
    var navCloseMarkup = '<button class="nav-toggle nav-toggle--close"><img src="/wp-content/themes/cgit-qc-hub/dist/images/icons/close.png" alt=""></button>';
    $('.site_header__logo').append(navOpenMarkup);
    $('.site_header__logo').append(navCloseMarkup);

    // Nav toggle
    $('.nav-toggle--close').addClass('hidden');

    $('.nav-toggle--open').on('click', function () {
        $(this).toggleClass('hidden');
        $('.nav-toggle--close').toggleClass('hidden');
        $('.site_header__navigation-links').toggleClass('hidden');
        $('.site_header__navigation').toggleClass('hidden');
    });

    $('.nav-toggle--close').on('click', function () {
        $(this).toggleClass('hidden');
        $('.nav-toggle--open').toggleClass('hidden');
        $('.site_header__navigation-links').toggleClass('hidden');
        $('.site_header__navigation').toggleClass('hidden');
    });

    // Sub-menu toggle
    $('.menu-item-has-children .nav-icon').each(function () {

        $(this).on('click', function (e) {

            // Prevent the default action from running
            e.preventDefault();

            // Define the sub-menu
            var subMenu = $(this).parent('a').next('.sub-menu');

            // Remove active states from all nav icons except the current one that has been clicked
            $(this).toggleClass('active');
            $('.nav-icon').not($(this)).removeClass('active');

            // Remove active states from all sub-menus except the current one
            $('.sub-menu').not(subMenu).addClass('hidden');

            // Toggle the active state of the current sub-menu on click
            subMenu.toggleClass('hidden');

        });

    });

    // Hack to set active state on parent menu items. Needed for custom links
    // in secondary or lower levels.
    $('.current-menu-item').closest('.menu-item-has-children').addClass('current-menu-parent');

    // Special case where a 3rd level is active, the 2nd level active state
    // shows, but not the top level. We cannot use current-page-ancestor because
    // that makes the sub-site home active too.
    $('ul ul .current-page-ancestor').parents('.current-page-ancestor').first().addClass('current-menu-parent');
});
